import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { Table, Badge, UncontrolledTooltip } from 'reactstrap'
import { Link } from 'react-router-dom'
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc'
import SortableTableHeader from '../../components/SortableTableHeader'
import {
  FaBars,
  FaSquareO,
  FaClockO,
  FaCheckSquareO
} from 'react-icons/lib/fa'
import styles from './PagesTable.scss'

// Sortable page table components

const DragHandle = SortableHandle(() => <span className={styles.dragHandle} title='Reorder'><FaBars />&nbsp;</span>)
// When running tests, return regular tr and tbody
const SortableRow = process.env.NODE_ENV === 'test' ? ({children}) => <tr>{children}</tr> : SortableElement(({children}) => <tr>{children}</tr>) // eslint-disable-line
const SortableTableBody = process.env.NODE_ENV === 'test' ? ({children}) => <tbody>{children}</tbody> : SortableContainer(({children}) => <tbody>{children}</tbody>) // eslint-disable-line

const sortableHeaders = {
  title: 'Title',
  slug: 'Slug',
  showTab: 'Show Tab',
  updatedAt: 'Updated Date',
  updatedBy: 'Updated By'
}

const DisplayPath = (path) => {
  const parts = path.split('/').slice(1)
  return parts.map((x, i) => {
    const isLast = i === parts.length - 1
    const style = {
      color: isLast ? 'inherit' : '#ccc'
    }
    const attrs = {style}
    return <span {...attrs} key={x}>/{x}</span>
  })
}

const PagesTable = (props) => (
  <Table className='mt-2'>
    <thead>
      <tr>
        {
          Object.keys(sortableHeaders).map(type =>
            (props.fragments && type === 'showTab') ? null : <SortableTableHeader key={type} type={type}
              label={sortableHeaders[type]}
              onClick={props.onSorts[type]}
              sortDirection={props.sortDirection}
              sortBy={props.sortBy} />
          )
        }
      </tr>
    </thead>
    <SortableTableBody onSortEnd={props.onPageSort} useDragHandle>
      {props.pages.map((row, i) =>
        <SortableRow key={i} index={i}>
          <td>
            {!props.fragments && props.onPageSort && <DragHandle />}
            <Link to={'/pages/edit/' + row.id}>
              {row.title}
              {
                row.slug !== 'fragments' && row.draftId &&
                <Badge className='ml-1' id={i + 'draft'}>
                  D
                  {process.env.NODE_ENV !== 'test' && <UncontrolledTooltip target={i + 'draft'}>Has Draft</UncontrolledTooltip>}
                </Badge>
              }
              {
                row.scheduledFor &&
                !isNaN(moment(row.scheduledFor)) &&
                moment().diff(moment(row.scheduledFor)) <= 0 &&
                <Badge className='ml-1' id={i + 'scheduledFor'}>
                  <FaClockO />
                  {process.env.NODE_ENV !== 'test' && <UncontrolledTooltip target={i + 'scheduledFor'}>Will publish {moment(row.scheduledFor).fromNow()}</UncontrolledTooltip>}
                </Badge>
              }
              {
                row.publishedId &&
                <Badge className='ml-1' color='primary' id={i + 'published'}>
                  {process.env.NODE_ENV !== 'test' && <UncontrolledTooltip target={i + 'published'}>Is Published</UncontrolledTooltip>}
                P
                </Badge>
              }
            </Link>
          </td>
          <td>
            {
              !row.path
              ? (row.slug !== 'fragments' && row.slug)
              : DisplayPath(row.path)
            }
          </td>
          {!props.fragments && <td>{row.slug !== 'fragments' && (parseInt(row.showTab) ? <FaCheckSquareO /> : <FaSquareO />)}</td>}
          <td>{moment(row.updatedAt).fromNow()}</td>
          <td>{`${(row.updatedBy.firstName || row.updatedBy.lastName) ? row.updatedBy.firstName + ' ' + row.updatedBy.lastName : row.updatedBy.email}`}</td>
        </SortableRow>
      )}
    </SortableTableBody>
  </Table>
)

PagesTable.propTypes = {
  sortBy: PropTypes.string,
  pages: PropTypes.array,
  fragments: PropTypes.bool,
  onPageSort: PropTypes.func
}

PagesTable.defaultProps = {
  onSorts: {}
}

export default PagesTable



// WEBPACK FOOTER //
// ./src/components/PagesTable/PagesTable.js